module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-7-512.b25913174c1e4e30.png"+" 512w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-7-512.b25913174c1e4e30.png",width: 512,height: 341}],
        src: "https://static.sniffspot.com/packs/img/bp-7-512.b25913174c1e4e30.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-7-512.b25913174c1e4e30.png"},
        
        width: 512,
        height: 341
      }